import React from 'react'
import { dateTimeAgo } from 'src/utils/datetime-utils'

import { StatusIcon } from '../../status-icon'
import { DeviceInfoRow } from './shared'

interface TrackingStatusSectionProps {
  isTrackingOn?: boolean
  isLoggedIn?: boolean
  lastTrackingStoppedAt: string | null
}

const EndedInfo = React.memo(({ endDate }: { endDate: string | null }) => {
  const computeRelative = React.useCallback(() => (endDate ? dateTimeAgo(endDate) : null), [endDate])
  const [relativeTime, setRelativeTime] = React.useState<string | null>(computeRelative)

  React.useEffect(() => {
    setRelativeTime(computeRelative())

    if (!endDate) return

    const id = setInterval(() => {
      setRelativeTime(computeRelative())
    }, 60_000)

    return () => clearInterval(id)
  }, [endDate, computeRelative])

  return <>The driver is currently off duty{relativeTime ? ` (${relativeTime})` : ''}.</>
})

export const TrackingStatusSection = ({
  isTrackingOn,
  isLoggedIn,
  lastTrackingStoppedAt
}: TrackingStatusSectionProps) => (
  <>
    {isTrackingOn !== undefined && (
      <DeviceInfoRow icon={<StatusIcon isPositive={isTrackingOn} />}>
        {isTrackingOn ? 'The driver is currently on duty.' : <EndedInfo endDate={lastTrackingStoppedAt ?? null} />}
      </DeviceInfoRow>
    )}

    {isLoggedIn !== undefined && (
      <DeviceInfoRow icon={<StatusIcon isPositive={isLoggedIn} />}>
        {isLoggedIn ? 'The driver is currently logged in.' : 'The driver is currently logged out.'}
      </DeviceInfoRow>
    )}
  </>
)
